import { render } from "./Icon.vue?vue&type=template&id=0f3929d8"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/vacatia/releases/20150122151115/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__